const initialState = {
    userValue: {
        UserId: '',
        UserName: '',
        Role: '',
        // Role: 'Co',
        RoleId: '',
        RoleAccess: '',
        isHnCActive: '',
        AssetAccessToken: '',
        HeaderAccessToken: '',
        impersonAccess: false,

        DataUploadApprovePageAccess: [],
        ReloadZylemDataPageAccess: [],
        DataMappingPageAccess: [],
        EnableReuploadPageAccess: [],
        DistributorConfigurationPageAccess: [],
        SystemConfigurationPageAccess: [],
        MastersPageAccess: [],
        ReportPageAccess: [],
        DashboardPageAccess: [],
        DataUploadPageAccess: [],
        SNSUploadPageAccess: [],
        OnlineEntryPageAccess: [],
        MonthClosurePageAccess: [],
        DataPageAccess: [],
        HelpTopicPageAccess: [],
        AddEditHelpTopicsPageAccess: [],
        AdminMastersPageAccess: [],
        SubCategoryPageAccess: [],
        HelpAndCommunicationPageAccess: [],
    },
    previousUserValue: null,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USERS':
            return {
                ...state,
                userValue: action.payload,
                previousUserValue: null, 
            };
        case 'SWITCH_USER':
            return {
                ...state,
                previousUserValue: state.previousUserValue ?? state.userValue,
                userValue: action.payload,
            };

        case 'REVERT_USER':
            return {
                ...state,
                userValue: state.previousUserValue,
                previousUserValue: null,
            };
        case 'LOGOUT':
            return {
                ...state,
                userValue: initialState.userValue, // Reset userValue to its initial state on logout
            };
        default:
            return state;
    }
};

export default userReducer;